import {useMemo} from 'react'
import PropTypes from 'prop-types'
import {List, Map} from 'immutable'

import CloseIcon from '@mui/icons-material/Close'

import UserAvatar from '../../../../shared_components/mui_base_components/avatar/UserAvatar'

import {findContactDeputy} from '../../../../lib/deputyPermissionTools'
import {humanizedFullName} from '../../../../lib/nameTools'

import './suggestedDeputyBox.scss'

const SuggestedDeputyBox = ({contact, onDismiss, onInvite, deputies = List()}) => {
  const contactDeputy = useMemo(
    () => findContactDeputy({contact, deputies}),
    [contact, deputies]
  )

  const displayName =
    humanizedFullName(contact) ||
    (contact.get('emails') || List()).first() ||
    contact.get('company-name') ||
    'Unknown contact'

  const buttonText = !contactDeputy.isEmpty() ? 'Share' : 'Invite'

  return (
    <div className='suggested-deputy-box'>
      <div className='suggested-deputy-box__avatar-details-button-container'>
        <UserAvatar className='suggested-deputy-box__avatar' user={contact} />
        <div className='suggested-deputy-box__details-button-container'>
          <div className='suggested-deputy-box__details'>
            <div className='suggested-deputy-box__name'>
              {displayName}
            </div>
            <div className='suggested-deputy-box__description'>
              Responsible for your arrangements
            </div>
          </div>
          <button
            className='suggested-deputy-box__invite-button'
            onClick={() => onInvite(contact)}
            type='button'>
            {buttonText}
          </button>
        </div>
      </div>
      <button
        aria-label={`Dismiss ${displayName}`}
        className='suggested-deputy-box__dismiss-button'
        onClick={() => onDismiss(contact)}
        type='button'>
        <CloseIcon />
      </button>
    </div>
  )
}

SuggestedDeputyBox.propTypes = {
  contact: PropTypes.instanceOf(Map).isRequired,
  onDismiss: PropTypes.func.isRequired,
  onInvite: PropTypes.func.isRequired,
  deputies: PropTypes.instanceOf(List)
}

export default SuggestedDeputyBox
